<div class="p-field">
  <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
    <h6 class="p-text-bold p-m-0">Call to Action</h6>
    <p-inputSwitch
      [(ngModel)]="feature.cta"
      [ngModelOptions]="{standalone: true}">
    </p-inputSwitch>
  </div>
  <small class="p-d-block p-mb-3 p-text-muted">Add a button that opens a website or app</small>

  <div class="p-fluid" *ngIf="feature.cta">
    <div class="p-field p-mb-3">
      <h6 class="p-text-bold p-mb-2">Button Name</h6>
      <input pInputText
             autocorrect="off"
             spellcheck="false"
             autocomplete="off"
             placeholder="Button Name"
             [(ngModel)]="feature.ctaName">
    </div>
    <div class="p-field">
      <h6 class="p-text-bold p-mb-2">URL</h6>
      <input pInputText
             type="url"
             spellcheck="false"
             autocomplete="off"
             placeholder="Enter URL"
             [(ngModel)]="feature.ctaUrl">
    </div>
  </div>
</div>